import clsx from "clsx";
import type { PropsWithChildren } from "react";

import { useDrawerContext } from "@/components/Drawer/DrawerContext";

type DrawerFooterProps = PropsWithChildren<{
  // Temporarily support a "drawer" variant till the DZR-1807 is done
  variant?: "default" | "drawer";
}>;

export function DrawerFooter({
  variant = "default",
  children,
}: DrawerFooterProps) {
  const { backgroundColor } = useDrawerContext();

  return (
    <div
      className={clsx(
        "sticky bottom-0 z-10 border-t border-t-stroke-neutral-soft px-main pt-4",
        {
          "bg-white": backgroundColor === "white",
          "bg-surface-background": backgroundColor === "background",
          "rounded-t-4xl bg-white shadow-[0_-1px_12px_0_rgba(0,0,0,0.08),0_-4px_12px_0_rgba(0,0,0,0.04)]":
            variant === "drawer",
        },
      )}
    >
      {children}
    </div>
  );
}
